export const webhookMonitoringDashboardPanelSx = {
	borderRadius: '8px',
	padding: '20px 24px',
	boxShadow: '0px 0px 1px rgba(0, 58, 53, 0.2), 4px 4px 8px rgba(0, 58, 53, 0.2)',
	border: '1px solid #f0f0f0',
} as const;
